import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/** Real, scannable QR (error correction M) drawn as one SVG path — same look as the prototype's `.qr`. */
export function Qr({ text, px = 188, dark = '#17140F', label = 'Bilet QR kodu' }: { text: string; px?: number; dark?: string; label?: string }) {
  const { n, d } = useMemo(() => {
    const q = qrcode(0, 'M');
    q.addData(text);
    q.make();
    const n = q.getModuleCount();
    let d = '';
    for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (q.isDark(y, x)) d += `M${x} ${y}h1v1h-1z`;
    return { n, d };
  }, [text]);
  return (
    <svg width={px} height={px} viewBox={`0 0 ${n} ${n}`} shapeRendering="crispEdges" role="img" aria-label={label}>
      <path d={d} fill={dark} />
    </svg>
  );
}

export function qrSvgString(text: string, px: number, dark = '#17140F') {
  const q = qrcode(0, 'M');
  q.addData(text);
  q.make();
  const n = q.getModuleCount();
  let d = '';
  for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (q.isDark(y, x)) d += `M${x} ${y}h1v1h-1z`;
  return `<svg width="${px}" height="${px}" viewBox="0 0 ${n} ${n}" shape-rendering="crispEdges" role="img" aria-label="QR"><path d="${d}" fill="${dark}"/></svg>`;
}
